import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorCloseOrderCreate = () => {
  const { t } = useTranslation()
  const closeOrderCreate = useCallback(
    (payload) => {
      ApiService.jsonRequest('/transaction-close/create', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t('response_message.send_success'),
            timer: 2000,
            reload: true,
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t(`response_message.${response.messages}`),
            timer: 3000,
            reload: false,
          })
        }
      })
    },
    [t],
  )
  return { closeOrderCreate }
}

export default InteractorCloseOrderCreate
